import { render, staticRenderFns } from "./SidenavLink.vue?vue&type=template&id=59e14bee&"
import script from "./SidenavLink.vue?vue&type=script&lang=js&"
export * from "./SidenavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports